import { Box, Button, makeStyles } from '@material-ui/core';
import React from 'react';
import { useDispatch } from 'react-redux';
import { RootState, useSelector } from 'src/store';
import {
  editCurrentBranchIndex,
  editCurrentIndex
} from 'src/store/modules/imageUpload';

const useStyles = makeStyles(() => ({
  scrollNumberBox: {
    margin: 'auto',
    display: 'flex',
    alignItems: 'center',
    gap: '32px',
    overflowX: 'scroll'
  },
  branchNumberBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  numberBox: {
    display: 'flex',
    gap: '8px'
  },
  number: {
    maxWidth: '2rem',
    minWidth: '2rem',
    maxHeight: '2rem',
    minHeight: '2rem',

    color: '#000',
    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400,

    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    backgroundColor: '#E0E0E0'
  }
}));

const NumberScroll = ({ branch, setCurrentPage }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  let currentBranchIndex = useSelector(
    (state: RootState) => state.imageUpload.currentBranchIndex
  );
  let currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  let bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  let text = useSelector((state: RootState) => state.editText.text);

  const NUMBER_ACTION_STYLE = (idx, idx2, idx3, action, none) => {
    return currentBranchIndex === ''
      ? idx === 0 && idx2 === 0 && currentIndex === idx3
        ? action
        : none
      : Number(currentBranchIndex[0] + currentBranchIndex[1]) === idx + 1 &&
        Number(currentBranchIndex[2] + currentBranchIndex[3]) === idx2 + 1
      ? action
      : none;
  };

  return (
    <Box className={classes.scrollNumberBox}>
      {branch?.map((branch_len: number, idx: number) => {
        return (
          <Box key={idx} className={classes.branchNumberBox}>
            {[...Array(branch_len)]?.map((_, idx2: number) => {
              const CURRENT_BRANCH_INDEX = `${String(idx + 1).padStart(
                2,
                '0'
              )}${String(idx2 + 1).padStart(2, '0')}`?.replaceAll('0101', '');
              const CURRENT_BRANCH =
                CURRENT_BRANCH_INDEX === '' ? '' : `_${CURRENT_BRANCH_INDEX}`;
              const LEN =
                bgImage?.['background' + CURRENT_BRANCH]?.length ||
                bgImage?.['image' + CURRENT_BRANCH]?.length ||
                text?.['text' + CURRENT_BRANCH]?.length;

              return (
                <Box key={idx2} className={classes.numberBox}>
                  {[...Array(LEN)]?.map((_, idx3: number) => {
                    return (
                      <Box
                        key={idx3}
                        className={classes.number}
                        style={{
                          color: NUMBER_ACTION_STYLE(
                            idx,
                            idx2,
                            idx3,
                            '#000',
                            '#828282'
                          ),
                          border: NUMBER_ACTION_STYLE(
                            idx,
                            idx2,
                            idx3,
                            '1.4px solid #000',
                            '1px solid #828282'
                          )
                        }}
                        onClick={() => {
                          dispatch(
                            editCurrentBranchIndex(CURRENT_BRANCH_INDEX)
                          );
                          dispatch(editCurrentIndex(idx3));

                          let newPage = branch.length === 1 ? '' : idx + 1;
                          newPage += branch_len === 1 ? '' : `-${idx2 + 1}`;
                          newPage += !LEN || LEN === 1 ? '' : `${idx3 + 1}`;
                          setCurrentPage(newPage);
                        }}
                      >
                        {branch.length === 1 ? '' : idx + 1}
                        {branch_len === 1 ? '' : `-${idx2 + 1}`}
                        {!LEN || LEN === 1 ? '' : `${idx3 + 1}`}
                      </Box>
                    );
                  })}
                </Box>
              );
            })}
          </Box>
        );
      })}
    </Box>
  );
};

export default NumberScroll;
